<script lang="ts">
  import {  Col,PaginationItem, PaginationLink,Pagination} from "sveltestrap";
  import { href } from "../../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <div class="job-pagination">
        <nav aria-label="Page navigation example">
            <Pagination color="primary">
                <PaginationItem disabled>
                    <PaginationLink href={href}>Previous</PaginationLink>
                </PaginationItem>
                <PaginationItem active>
                    <PaginationLink href={href}>1</PaginationLink>
                </PaginationItem>
                <PaginationItem >
                    <PaginationLink href={href}>2</PaginationLink>
                </PaginationItem>
                <PaginationItem >
                    <PaginationLink href={href}>3</PaginationLink>
                </PaginationItem>
                <PaginationItem >
                    <PaginationLink href={href}>Next</PaginationLink>
                </PaginationItem>    
            </Pagination>
        </nav>
    </div>
</Col>